export default __webpack_public_path__ + "media/aaf8f34703cd98b8e3e1c78f99298c7b7ccc45dd6eaf8f774f17216b4c172b56.svg";